import { ViewMore } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { FilterTagsHalfClosedTagListProps as Props } from './types';
import { useRenderTagList } from './use-render-tag-list';

const VIEW_MORE_BUTTON_PROPS = {
  variant: 'contained' as const,
  size: 'small' as const,
};

export const FilterTagsHalfClosedTagList = memo(
  ({ className, tags }: Props) => {
    const list = useRenderTagList(tags);

    return (
      <Styled.Wrapper
        className={classnames('FilterTagsHalfClosedTagList', className)}
        sx={SX.root}
      >
        <ViewMore
          limit={5}
          displayTags={3}
          list={list}
          buttonProps={VIEW_MORE_BUTTON_PROPS}
        />
      </Styled.Wrapper>
    );
  }
);

FilterTagsHalfClosedTagList.displayName = 'FilterTagsHalfClosedTagList';
